import KpiCard from "./charts/KpiCard";

/** Renders a grid of KPI cards from existing metric descriptors (no logic changes). */
export default function MetricGrid({ items, onDrill, className = "" }) {
  return (
    <div className={`stats-grid ${className}`}>
      {items.map((k) => {
        const Icon = k.icon;
        const clickable = k.drill && onDrill;
        return (
          <KpiCard
            key={k.key || k.label}
            label={k.label}
            value={k.value}
            icon={Icon}
            comparison={k.sub}
            trend={k.trend}
            trendLabel={k.trendLabel}
            sparkline={k.sparkline}
            accent={k.accent || "primary"}
            onClick={clickable ? () => onDrill(k.drill) : k.onClick}
            as={clickable || k.onClick ? "button" : "div"}
          >
            {k.extra || null}
          </KpiCard>
        );
      })}
    </div>
  );
}
